// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductsPerPage_container__MK_bU"};